import { render, staticRenderFns } from "./NOTTODashboard.vue?vue&type=template&id=2ad0d08f"
import script from "./NOTTODashboard.vue?vue&type=script&lang=js"
export * from "./NOTTODashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports